<template>
  <div class="print-wrap">

    <!-- ══════════════════════════════════════════
         PAGE 1 : 관리감독자 점검 항목
    ══════════════════════════════════════════ -->

    <!-- 헤더 -->
    <div class="page-header">
      <img src="@/assets/images/동국제강_로그인.svg" class="logo" />
      <h1 class="page-title">관리감독자 Check List</h1>
    </div>

    <!-- 관리감독자 정보 + 점검 일시 -->
    <table class="meta-table">
      <tbody>
        <tr>
          <td class="meta-label">■ 관리감독자</td>
          <td class="meta-value">
            {{ form.관리감독자정보.부서명 }}&nbsp;&nbsp;
            {{ form.관리감독자정보.직급 }}&nbsp;&nbsp;
            {{ form.관리감독자정보.이름 }}
          </td>
          <td class="meta-label">■ 점검 일시</td>
          <td class="meta-value">{{ form.점검일 }} {{ form.점검시간 }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 관리감독자 점검 항목 테이블 -->
    <table class="inspect-table">
      <colgroup>
        <col style="width: 70px" />
        <col />
        <col style="width: 52px" />
        <col style="width: 52px" />
        <col style="width: 60px" />
        <col style="width: 180px" />
      </colgroup>
      <thead>
        <tr class="table-section-title">
          <th colspan="6">관리감독자 점검 항목</th>
        </tr>
        <tr>
          <th>유형</th>
          <th>점검 항목</th>
          <th>양호</th>
          <th>불량</th>
          <th>해당 없음</th>
          <th>비고<br/>(조치사항 기재)</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(group, gi) in groupedInspectItems">
          <!-- textarea (기타) -->
          <tr v-if="group.isTextarea" :key="`inspect-textarea-${gi}`">
            <td class="group-cell">{{ group.title }}</td>
            <td colspan="5" class="textarea-cell">{{ group.item[''] }}</td>
          </tr>
          <!-- 일반 항목 -->
          <template v-else v-for="(item, ii) in group.items">
            <tr :key="`inspect-${gi}-${ii}`">
              <td v-if="ii === 0" :rowspan="group.items.length" class="group-cell">{{ group.title }}</td>
              <td class="content-cell">{{ item.content }}</td>
              <td class="check-cell"><span class="print-checkbox"><i><feather-icon v-if="item.isChecked === '양호'" svgClasses="w-4 h-4" icon="CheckIcon" /></i></span></td>
              <td class="check-cell"><span class="print-checkbox"><i><feather-icon v-if="item.isChecked === '불량'" svgClasses="w-4 h-4" icon="CheckIcon" /></i></span></td>
              <td class="check-cell"><span class="print-checkbox"><i><feather-icon v-if="item.isChecked === '해당없음'" svgClasses="w-4 h-4" icon="CheckIcon" /></i></span></td>
              <td class="note-cell">{{ item[NOTE_KEY] }}</td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>

    <!-- 비상 연락망 -->
    <p class="emergency-note">비상 연락망 : 안전환경팀 스마트 통합관제지원실 (054-721-3555)</p>


    <!-- ══════════════════════════════════════════
         PAGE 2 : 작업시작전 점검사항
    ══════════════════════════════════════════ -->
    <div class="page-break"></div>

    <!-- 헤더 -->
    <div class="page-header">
      <img src="@/assets/images/동국제강_로그인.svg" class="logo" />
      <h1 class="page-title">작업시작전 점검사항</h1>
    </div>

    <!-- 작업시작전 점검사항 테이블 -->
    <table class="inspect-table">
      <colgroup>
        <col style="width: 120px" />
        <col />
        <col style="width: 52px" />
        <col style="width: 52px" />
        <col style="width: 60px" />
        <col style="width: 180px" />
      </colgroup>
      <thead>
        <tr>
          <th>점검사항</th>
          <th>점검내용</th>
          <th>양호</th>
          <th>불량</th>
          <th>해당없음</th>
          <th>비고<br/>(조치사항 기재)</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(group, gi) in groupedWorkItems">
          <!-- textarea (조치 및 개선 내역) -->
          <tr v-if="group.isTextarea" :key="`work-textarea-${gi}`">
            <td class="group-cell">{{ group.title }}</td>
            <td colspan="5" class="textarea-cell">{{ group.item[''] }}</td>
          </tr>
          <!-- 일반 항목 -->
          <template v-else v-for="(item, ii) in group.items">
            <tr :key="`work-${gi}-${ii}`">
              <td v-if="ii === 0" :rowspan="group.items.length" class="group-cell">{{ group.title }}</td>
              <td class="content-cell">{{ item.content }}</td>
              <td class="check-cell"><span class="print-checkbox"><i><feather-icon v-if="item.isChecked === '양호'" svgClasses="w-4 h-4" icon="CheckIcon" /></i></span></td>
              <td class="check-cell"><span class="print-checkbox"><i><feather-icon v-if="item.isChecked === '불량'" svgClasses="w-4 h-4" icon="CheckIcon" /></i></span></td>
              <td class="check-cell"><span class="print-checkbox"><i><feather-icon v-if="item.isChecked === '해당없음'" svgClasses="w-4 h-4" icon="CheckIcon" /></i></span></td>
              <td class="note-cell">{{ item[NOTE_KEY] }}</td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>

  </div>
</template>

<script>
const NOTE_KEY = "비고(조치사항 기재)";

export default {
  name: "Print1140",
  props: {
    form: Object,
    board: Object,
  },
  data() {
    return { NOTE_KEY };
  },
  computed: {
    groupedInspectItems() {
      return this.groupItems(this.form.관리감독자점검항목 || []);
    },
    groupedWorkItems() {
      return this.groupItems(this.form.작업시작전점검사항 || []);
    },
  },
  methods: {
    groupItems(items) {
      const groups = [];
      let current = null;
      for (const item of items) {
        if (item.rowType === 'textarea') {
          groups.push({ isTextarea: true, title: item.title, item });
          current = null;
          continue;
        }
        if (!current || current.title !== item.title) {
          current = { title: item.title, items: [] };
          groups.push(current);
        }
        current.items.push(item);
      }
      return groups;
    },
  },
};
</script>

<style lang="scss" scoped>
.print-wrap {
  padding: 20px 24px;
  font-size: 12px;
  color: #1a1a1a;
  background: #fff;
}

/* 헤더 */
.page-header {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 12px;

  .logo {
    height: 32px;
  }

  .page-title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 22px;
    font-weight: 700;
    white-space: nowrap;
  }
}

/* 관리감독자 정보 행 */
.meta-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 4px;
  border: 1px solid #999;

  td {
    padding: 6px 10px;
    font-size: 12px;
    border: 1px solid #999;
  }

  .meta-label {
    font-weight: 700;
    white-space: nowrap;
    background: #f5f5f5;
    width: 90px;
  }

  .meta-value {
    min-width: 200px;
  }
}

/* 점검 테이블 공통 */
.inspect-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th, td {
    border: 1px solid #999;
    font-size: 11px;
    padding: 5px 6px;
    vertical-align: middle;
  }

  th {
    background: #f0f0f0;
    font-weight: 600;
    text-align: center;
  }

  .table-section-title th {
    background: #e8e8e8;
    font-size: 13px;
    font-weight: 700;
    text-align: center;
    padding: 6px;
  }

  .group-cell {
    text-align: center;
    font-weight: 600;
    background: #fafafa;
    word-break: keep-all;
    font-size: 11px;
  }

  .content-cell {
    text-align: left;
    word-break: keep-all;
    line-height: 1.5;
  }

  .check-cell {
    text-align: center;
    padding: 4px;
  }

  .note-cell {
    text-align: left;
    font-size: 11px;
    word-break: break-all;
  }

  .textarea-cell {
    text-align: left;
    min-height: 60px;
    padding: 8px;
  }
}

/* 비상 연락망 */
.emergency-note {
  margin-top: 8px;
  font-size: 11px;
  font-weight: 600;
}

/* 페이지 나누기 */
.page-break {
  page-break-before: always;
  margin-top: 40px;
}
</style>

<style lang="scss">
.print-checkbox {
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border: 1.5px solid #999;
  }
}
</style>
